import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const faqs = [
  {
    q: "Ist die Teilnahme wirklich kostenlos?",
    a: "Ja. Die Teilnahme ist vollständig kostenlos und nicht an einen Kauf oder Vertragsabschluss gebunden.",
  },
  {
    q: "Wer darf teilnehmen?",
    a: "Volljährige Personen ab 18 Jahren mit Wohnsitz bzw. Steuerpflicht in der Schweiz.",
  },
  {
    q: "Was kann ich gewinnen?",
    a: "Es gibt 26 Gewinner: 1× 7 Jahre Steuererklärung gratis (Hauptpreis), 20× eine Steuererklärung 2027 gratis und 5× CHF 100 Cash.",
  },
  {
    q: "Wann werden Gewinner gezogen?",
    a: "Wöchentlich: am 14., 21. und 28. September sowie am 5. Oktober 2026. Die finale Ziehung mit dem Hauptpreis findet am 8. Oktober 2026 statt.",
  },
  {
    q: "Kann ich mehrfach gewinnen?",
    a: "Pro Person gibt es maximal einen Wochen- oder Zusatzpreis. Wochengewinner bleiben aber für den Hauptpreis qualifiziert – und wer nicht gewinnt, rutscht automatisch in die nächste Ziehung.",
  },
  {
    q: "Wie werde ich informiert?",
    a: "Gewinner werden nach der jeweiligen Ziehung telefonisch und per E-Mail kontaktiert.",
  },
  {
    q: "Warum wird meine Handynummer benötigt?",
    a: "Für die Teilnahme und den telefonischen Kontakt – unter anderem, damit wir dich im Gewinnfall schnell erreichen. Details stehen in der Datenschutzerklärung.",
    link: true,
  },
  {
    q: "Was passiert mit meinen Daten?",
    a: "Deine Angaben werden für die Durchführung des Wettbewerbs verwendet und können gemäss Datenschutzerklärung an ausgewählte Partner weitergegeben werden. Du kannst deine Zustimmung jederzeit widerrufen.",
    link: true,
  },
  {
    q: "Was ist das Steuer-Sparpaket 2027?",
    a: "Dein garantierter Sofortbonus: ein PDF mit 23 Prüfpunkten, einer kompletten Unterlagen-Checkliste und einem 5-Minuten-Steuercheck. Jeder gültige Teilnehmer erhält es sofort per E-Mail.",
  },
];

export const Faq = () => (
  <section id="faq" className="scroll-mt-20 bg-offwhite py-16 md:py-24" data-testid="faq-section">
    <div className="mx-auto max-w-[760px] px-5">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold-dark">FAQ</p>
        <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink md:text-5xl">
          Häufige Fragen.
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-8" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-line">
              <AccordionTrigger
                data-testid={`faq-question-${i + 1}`}
                className="py-5 text-left font-display text-lg font-bold text-ink hover:text-gold-dark hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 leading-relaxed text-mutedlight">
                {f.a}
                {f.link && (
                  <>
                    {" "}
                    <Link to="/datenschutz" className="text-gold-dark underline underline-offset-2 hover:text-gold">
                      Zur Datenschutzerklärung
                    </Link>
                  </>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
